// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  filesUploadRequest: ['data'],
  filesUploadSuccess: ['data'],
  filesUploadFailure: ['err'],
  filesUploadReset: null,
})

export const FilesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  err: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, err: null, data: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const reset = (state: Object) => 
  state.merge({
    fetching: false,
    data: null,
    err: null
  })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.FILES_UPLOAD_SUCCESS]: success,
  [Types.FILES_UPLOAD_REQUEST]: request,
  [Types.FILES_UPLOAD_FAILURE]: failure,
  [Types.FILES_UPLOAD_RESET]: reset,
})



// WEBPACK FOOTER //
// ./src/Redux/FilesRedux.js